import React from 'react';
import './Explorestyle.css';
import AIheader from "../RentAI/AIheader";
import JoinWaitlistButton from '../../Component/ViralLoops/JoinWaitlistButton';
import Footer from "../../Component/Footer/Footer"; 
import Productdemo from '../../Component/Productdemo/Productdemo';

const ExploreDemo = () => {
  return (
    <div>

      <AIheader/>

        <section className='demo-baner'>
            <div className='demo-bnr-inr'>
              <h2>Experience Rentid in action</h2>
            </div>
        </section>

        <section className='demo-pro-title'>
          <div className='container'>
            <h2>Watch Product Demo</h2>
          </div>
        </section>

        <section className='demo-pro-video'>
          <div className='container'>
              <Productdemo/>
          </div>
        </section>


        <section className="landing_waitlist">
            <div className="container">
            <div className="row justify-content-center">
            <div className="col-lg-12 col-md-12 col-sm-12 col-12">
            <div className="landing_waitlistInner">
            <h2>Join the Rentid Waitlist</h2>
            <p>The only rental platform you’ll ever need</p>
            <div className="landing_waitlist_formBtn"> <a className="landing_waitlistbtn"><JoinWaitlistButton /><img src="/img/arrow-up-right.svg" alt="icon"/></a></div>
            {/* <div className="landing_waitlist_formBtn"><a className="landing_waitlistbtn" href="/">Join Waitlist<img src="/img/arrow-up-right.svg" alt="icon"/></a></div> */}
        
            </div>
            </div>
            </div>
            </div>
            </section>


     
  
      <Footer/>
    </div>
  )
}

export default ExploreDemo
